import Link from "next/link";
import React from "react";

const TextLink = ({ text, href, target }: { text: string; href: string; target?: React.HTMLAttributeAnchorTarget }) => {
  return (
    <Link className="text-link hover:underline" href={href} target={target}>
      {text}
    </Link>
  );
};
export default TextLink;
